import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);
  private router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status !== 401 || this.isAuthEndpoint(req.url)) {
          return throwError(() => err);
        }

        return from(this.auth.refreshToken()).pipe(
          switchMap(() => {
            const token = this.auth.accessToken;
            const retried = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
            return next.handle(retried).pipe(
              catchError((retryErr: HttpErrorResponse) => {
                if (retryErr.status === 401) this.redirectToLogin();
                return throwError(() => retryErr);
              })
            );
          }),
          catchError(e => {
            this.redirectToLogin();
            return throwError(() => e);
          })
        );
      })
    );
  }

  private isAuthEndpoint(url: string): boolean {
    return url.includes('/connect/token') || url.includes('/account/login');
  }

  private redirectToLogin(): void {
    this.auth.clearLocalSessionOnly();
    const current = this.router.url;
    const returnUrl = current && current !== '/login' ? current : undefined;
    this.router.navigate(['/login'], returnUrl ? { queryParams: { returnUrl } } : undefined);
  }
}
